export const problemas: string[] = [
  'Domingo a la noche improvisando qué cocinar para el lunes',
  'Heladera vacía a mitad de semana — delivery otra vez',
  'Siempre lo mismo: atún con lo que haya, sin plan proteico real',
  'Querés comer sano y con proteína pero no sabés por dónde empezar',
  'Gastás $50.000+ por semana en delivery sin darte cuenta',
  'Llegás agotado del trabajo y no hay nada proteico listo',
  'Las viandas al trabajo son siempre las mismas y aburridas',
  'El fin de semana volvés a empezar el mismo ciclo sin fin',
]
